import { createFileRoute } from '@tanstack/react-router';
import { RoutePlaceholder } from './-components/RoutePlaceholder';

export const Route = createFileRoute('/virtualsports')({
  component: () => (
    <RoutePlaceholder
      icon="virtual-button"
      title="Virtual sports"
      description="Simulated events and instant markets."
    />
  ),
});
